import { Injectable } from '@angular/core';
import { AngularMode, Module } from '@frontend-site/shared/data';
import { SessionRepository } from '../session';

const GAMode = [
    Module.Defect,
    Module.Correction,
    Module.Issues,
    Module.Feature,
    Module.Task,
    Module.Requirement,
    Module.Development,
    Module.Foresight,
    Module.ForesightAllComponents,
    Module.Tests,
    Module.TestTree,
    // RDX-03777: the S/4Convert-new Project Plan page is GA from 26.12.
    Module.UnifiedProjectPlan
];
const BetaMode = [...GAMode];
const AlphaMode = [...BetaMode];
const InternalMode = [Module.Configuration, ...AlphaMode];

@Injectable({ providedIn: 'root' })
export class AngularModeService {
    private readonly angularMode: AngularMode | undefined;

    constructor(private sessionRepository: SessionRepository) {
        this.angularMode = this.sessionRepository.applicationConfig?.angularMode;
    }

    public isNewUi(module: Module) {
        switch (this.angularMode) {
            case AngularMode.OLD_UI:
                return false;
            case AngularMode.INTERNAL:
                return isModuleInMode(InternalMode, module);
            case AngularMode.ALPHA:
                return isModuleInMode(AlphaMode, module);
            case AngularMode.BETA:
                return isModuleInMode(BetaMode, module);
            case AngularMode.GA:
                return isModuleInMode(GAMode, module);
            default:
                return false;
        }

        function isModuleInMode(modulesOfMode: Module[], module: Module) {
            return modulesOfMode.includes(module);
        }
    }
}
